import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

const buildFormData = (payload, attachments) => {
    const formData = new FormData();
    Object.keys(payload || {}).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
            formData.append(key, payload[key]);
        }
    });
    if (attachments && attachments.length) {
        attachments.forEach(file => {
            formData.append("attachments[]", file);
        });
    }
    return formData;
};

export const _Expenses = {
    save: (payload, attachments = []) => {
        const payloadWithToken = {
            ...(payload || {}),
            token: AuthAPI.getUserAccessToken()
        };

        if (attachments && attachments.length) {
            const formData = buildFormData(payloadWithToken, attachments);
            return new Promise((resolve, reject) => {
                fetch(APIConfig.url("/modulo-hr/expenses/save"), {
                    method: "POST",
                    body: formData
                })
                    .then(response => response.json())
                    .then(json => {
                        json.status === FuxHTTP.STATUS_SUCCESS ? resolve(json.data) : reject(json.message);
                    })
                    .catch(() => reject(null));
            });
        }

        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/save"),
            payloadWithToken,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    pagination: (id_dipendente, page = 1, filters = null, sortFields = null, trip_id = null) => {
        const params = {
            page: page,
            token: AuthAPI.getUserAccessToken()
        };

        if (trip_id) {
            params.trip_id = trip_id;
        } else if (Array.isArray(id_dipendente)) {
            params["id_dipendente[]"] = id_dipendente;
        } else {
            params.id_dipendente = id_dipendente;
        }

        if (filters) {
            params.filters = filters;
        }
        if (sortFields) {
            params.sortFields = typeof sortFields === "string" ? sortFields : JSON.stringify(sortFields);
        }

        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/pagination"),
            params,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    details: expense_id => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/details"),
            {
                expense_id: expense_id,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    approvedTotalDateRange: (id_dipendente, start_date, end_date) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/approved-total/date-range"),
            {
                id_dipendente: id_dipendente,
                start_date: start_date,
                end_date: end_date,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    delete: expense_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/delete"),
            {
                expense_id: expense_id,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    logsPagination: (expense_id, page = 1) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/logs/pagination"),
            {
                expense_id: expense_id,
                page: page,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    deleteAttachment: (expense_id, id_file) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/expenses/attachments/delete"),
            {
                expense_id: expense_id,
                id_file: id_file,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    uploadAttachments: (expense_id, attachments = []) => {
        const payload = {
            expense_id: expense_id,
            token: AuthAPI.getUserAccessToken()
        };
        const formData = buildFormData(payload, attachments);
        return new Promise((resolve, reject) => {
            fetch(APIConfig.url("/modulo-hr/expenses/attachments/upload"), {
                method: "POST",
                body: formData
            })
                .then(response => response.json())
                .then(json => {
                    json.status === FuxHTTP.STATUS_SUCCESS ? resolve(json.data) : reject(json.message);
                })
                .catch(() => reject(null));
        });
    }
};
